import { useEffect, useState } from "react";
import { NewBookingView } from "../firestore/Types/NewBookingSchema";
import { AvailabilitiesCollection, days, setTimes } from "../Utils/TimeSlotUtils";

export function SessionTimesPretty({ availabilitiesCollection, currentBookings,classNameCss }: { availabilitiesCollection: AvailabilitiesCollection | undefined, currentBookings: NewBookingView[] , classNameCss:string}) {
	const [selectedTimes, setSelectedTimes] = useState([] as string[][]);

	useEffect(() => {
		if (availabilitiesCollection) {
			const times = setTimes(availabilitiesCollection);
			setSelectedTimes(times);
		}
	}, [availabilitiesCollection]);

	return (
		<div className={classNameCss}>
			<div className="basic-form-label">
				Selected Availabilities
			</div>
			{
				(selectedTimes.every(day => day.length === 0))
				? <div className="basic-form-label pl-5">
					Please select an available time
				</div> : <></>
			}
			{displayAllTimes(selectedTimes)}
			
		</div>
	);
}

function displayAllTimes(times: string[][]) {
	return (
		times.map((day, index) => {
			if (day.length > 0) {
				return (
					<div key={index}>
						<div className="basic-form-label">
							{days[index]}:
						</div>
						<div className="ml-4">
							{displayTimes(day)}
						</div>
					</div>
				)
			}
			return (
				<div key={index}></div>
			)
		}));
}

function displayTimes(day: string[]) {
	return (
	day.map((times, index) => (
		<div className="flex flex-row" key={index}>
			<div className="border-l-4 border-b-4 border-indigo-500 h-3 w-3" />
			<div className="basic-form-label pl-2">
				{times}
				</div>
		</div>
	)));
}